import { Plugin } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';

export function composerPlaceholderPlugin(getPlaceholder) {
  return new Plugin({
    props: {
      decorations: state => {
        const decorations = [];
        state.doc.descendants((node, pos) => {
          if (state.doc.content.size === 2) {
            decorations.push(
              Decoration.node(pos, pos + node.nodeSize, {
                class: 'empty-node',
                'data-placeholder': getPlaceholder(),
              })
            );
          }
        });
        return DecorationSet.create(state.doc, decorations);
      },
    },
  });
}
